import {
	SET_SCHEDULE_AMOUNT,
	SET_SCHEDULE_FREQUENCY,
	SET_SCHEDULE_ADD_CASH_AMOUNT,
} from 'stash/actions/setSchedule';

export const initialState = {
	cashAmount: 50,
	amount: 5,
	frequency: 'WEEKLY',
};

const setSchedule = (state = initialState, action) => {
	switch (action.type) {
		case SET_SCHEDULE_AMOUNT: {
			return {
				...state,
				amount: action.amount,
			};
		}
		case SET_SCHEDULE_FREQUENCY: {
			return {
				...state,
				frequency: action.frequency,
			};
		}
		case SET_SCHEDULE_ADD_CASH_AMOUNT: {
			return {
				...state,
				cashAmount: action.amount,
			};
		}
		default:
			return state;
	}
};

export default setSchedule;
